import { css } from "@stubhub/broadway-foundation/css";

export const marginDivLarge = css({
  marginBlockStart: "primitives.200",
  marginBlockEnd: "primitives.200",
});
